import { FormFieldTypes } from "../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";


const initState = {
  projectName: "",
  projectCode: "",
  customerId: "",
  responsibleUser: "",
  projectStartDate: "",
  projectEndDate: "",
  billingCycleStartDate: "",
  projectDomainId: "",
  projectTypeId: "",
  description: "",
  isActive: true,
  isRequireTimesheetApproval: "",
  organizationId: "",
}

  export const projectsFormData = {
    name: "Project Form",
    initialState: initState,
    section: [
      {
        sectionId: 'projectForm',
        title: "Project Form",
        row: {},
        style: {
          sectionStyle: "col-lg-6 ",
        },
        wrapperTemplate: <div className="form-card row"></div>,
        fields: [
          {
            id: "projectName",
            label: "Project Name",
            Field_Name: "project name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "projectName",
            fieldSetting: {
              placeholder: "Please Enter Project Name",
              allowSpace: true,
              isDisable: false,
            },
            validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss:  "col-lg-6 col-md-6 validation-left-0",
            },
          },
          {
            id: "projectCode",
            label: "Project Code",
            Field_Name: "project Code",
            fieldType: FormFieldTypes.INPUT,
            dataField: "projectCode",
            fieldSetting: {
              placeholder: "Please Enter Project Code",
              allowSpace: true,
              // options: [],
            },
            // validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss: "col-lg-6 col-md-6",
            },
          },
          {
            id: "customerId",
            label: "Customer",
            Field_Name: "customer",
            fieldType: FormFieldTypes.SELECT,
            dataField: "customerId",
            fieldSetting: {
              placeholder: "Please Select Customer",
              allowSpace: true,
              options: [],
            },
            validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss: "col-lg-6 col-md-6",
            },
          },
          {
            id: "responsibleUser",
            label: "Responsible User",
            Field_Name: "responsible user",
            fieldType: FormFieldTypes.SELECT,
            dataField: "responsibleUser",
            fieldSetting: {
              placeholder: "Please Select Responsible User",
              allowSpace: true,
              options: [],
            },
            validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss:"col-lg-6 col-md-6 validation-left-0",
            },
          },
          {
            id: "projectTypeId",
            label: "Project Type",
            Field_Name: "project type",
            fieldType: FormFieldTypes.SELECT,
            dataField: "projectTypeId",
            fieldSetting: {
              placeholder: "Please Select Project Type",
              allowSpace: true,
              options: [],
            },
            validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss: "col-lg-6 col-md-6 validation-left-0",
            },
          },
          {
            id: "projectDomainId",
            label: "Project Domain",
            Field_Name: "project domain",
            fieldType: FormFieldTypes.SELECT,
            dataField: "projectDomainId",
            fieldSetting: {
              placeholder: "Please Select Project Domain",
              allowSpace: true,
              options: [],
            },
         //   validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss: "col-lg-6 col-md-6 validation-left-0",
            },
          },
          {
            id: "projectStartDate",
            label: "Start Date",
            Field_Name: "start date",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "projectStartDate",
            fieldSetting: {
              placeholder: "Please Enter Start Date",
              allowSpace: true,
              dateConfig: {
                dateFormat: "MM/dd/yyyy",
                showTimeSelect: true,
              }
            },
            validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss: "col-lg-6 col-md-6 validation-left-0"
            },
          },
          {
            id: "projectEndDate",
            label: "End Date",
            Field_Name: "end date",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "projectEndDate",
            fieldSetting: {
              placeholder: "Please Enter End Date",
              allowSpace: true,
              dateConfig: {
                dateFormat: "MM/dd/yyyy",
                showTimeSelect: true,
              }
            },
            style: {
              containerCss: "col-lg-6 col-md-6 validation-left-0"
            },
          },
          // {
          //   id: "billingCycleStartDate",
          //   label: "Billing Cycle Start Day",
          //   Field_Name: "billing cycle start day",
          //   fieldType: FormFieldTypes.NUMERIC,
          //   dataField: "billingCycleStartDate",
          //   fieldSetting: {
          //     placeholder: "Enter Day",
          //     allowSpace: true,
          //   },
          //   style: {
          //     containerCss: "validation-left-0 col-3 mb-1 text-nowrap",
          //   },
          // },
          {
            id: "isActive",
            label: "Is Active",
            Field_Name: "isActive",
            fieldType: FormFieldTypes.CHECKBOX,
            dataField: "isActive",
            fieldSetting: {
              allowSpace: true,
              
            },
            style: {
              containerCss: "col-lg-3 col-md-3 mb-0 double-label-sec checkbox-style",
            },
          },

          // {
          //   id: "isRequireTimeSheetApproval",
          //   label: "Is Require TimeSheet Approval",
          //   Field_Name: "is require timeSheet approval",
          //   fieldType: FormFieldTypes.CHECKBOX,
          //   dataField: "isRequireTimeSheetApproval",
          //   fieldSetting: {
          //     allowSpace: true,
          //   },
          //   style: {
          //     containerCss: "col-lg-3 col-md-6 mb-0 double-label-sec checkbox-style",
          //   },
          // },
        ]
      },
      {
        sectionId: 'projectForm',
        title: "Project Form",
        row: {},
        style: {
          sectionStyle: "col-lg-6 ",
        },
        wrapperTemplate: <div className="form-card row"></div>,
        fields: [
          
          {
            id: "description",
            label: "Description",
            Field_Name: "description",
            fieldType: FormFieldTypes.TEXTEDITOR,
            dataField: "description",
            fieldSetting: {
              placeholder: "Please Enter Description",
              allowSpace: true,
            },
            validation: [{ type: validationTypes.REQUIRE }],
            style: {
              containerCss: "validation-left-0 text-editor mb-1",
            },
          }

        ]
      }
    ]
  }

/** Table Column Configration */
export const ProjectGridConfig = {
  columns: [
    {
      name: "Project Name",
      fieldName: "projectName",
      allowShort: false,
    },
    {
      name: "Customer Name",
      fieldName: "customerName",
      allowShort: false,
    },

    {
      name: "Project Start Date",
      fieldName: "projectStartDate",
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD/MM/YYYY",
      },
      allowShort: false,
    },
    {
      name: "Project End Date",
      fieldName: "projectEndDate",
      colType: GridColumnType.DATE,
      colSettings: {
        format: "DD/MM/YYYY",
      },
      allowShort: false,
    },
    {
      name: "Status",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isActive",
      allowShort: false,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      // customAction: [
      //   {
      //     name: "TEAMS",
      //     iconName: AppIcons.userIcon,
      //   },
      // ],
    },
  ],
};
export default projectsFormData;